// extracted by mini-css-extract-plugin
export default {"content-popup":"ModalNotification_content-popup__V4oPL","button":"ModalNotification_button__bt62W","modal":"ModalNotification_modal__XB+qH"};